<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">任务服务费配置</span>
    </div>
    <el-tabs class="el-tabs-self" v-model="tabsActive" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.taskName" :name="item.id"></el-tab-pane>
    </el-tabs>

    <el-table :data="tableData"
              border
              default-expand-all
              stripe :header-cell-style="{'text-align':'center'}"
              cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              class="tb-edit"
              highlight-current-row
              @row-click="handleCurrentChange">
      <el-table-column prop="attach" label="附加项" align="right" />
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.servicePrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.servicePrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.chargesPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.chargesPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="启用">
        <template slot-scope="scope">
          <el-checkbox size="small" v-model="scope.row.isNeedUser" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="默认">
        <template slot-scope="scope">
          <el-checkbox size="small" v-model="scope.row.isDefault" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="排序(从小到大)">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.sorlData" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.sorlData}}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col :span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">重置</el-button>
        </el-col>
        <el-col :span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder" @click="handleSave">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import {getServiceMoney, updateServiceMoney} from "../../api/b2cbusiness/b2c_servicemoney";

export default {
  name: "TaskAttachPrice",
  data(){
    return {
      tableData: [
        {
          attach: "允许使用优惠券及红包",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "需要假聊",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "收藏店铺",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "收藏宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "允许使用信用卡",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "允许使用花呗",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "地域限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "年龄限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "性别限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "货比足迹",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "浏览目标宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "优质号",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "竟品",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "商家自主审核",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "任务标签",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "允许使用优惠券及红包",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "意向标签",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "核对商品链接",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "账号等级限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "淘气值限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "收货时间限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "浏览副宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "核验码",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "加入购物车",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "多链接",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "问大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "回答大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "点赞",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "评论问大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "推荐宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "降权包赔",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "7天内完成浏览单",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "旺旺本品打标",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "直播互动留言",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "自动验号",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "旺旺竟品打标",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "设定买家的浏览时间",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        }
      ],
      tabsActive: 1,
      tabsActives: [],
    }
  },
  mounted() {
    getAllTaskType().then(res => {
      console.log(res.data)
      if (res.success){
        this.tabsActives = res.data;
      }
    });
    getServiceMoney({btsId:0,
      b2cTaskTypeId:this.tabsActive,
      servicePrice:0,
      chargesPrice: 0}).then(res => {
      if (res.success){
        this.tableData = res.data;
      }
    });
  },
  methods: {
    handleClick(tab, event){
      console.log(tab, event)
      this.getData();
    },
    handleSave(){
      updateServiceMoney(this.tableData).then(res=>{
        console.log(res.data)
        if (res.success){
          this.getData();
        }
      });
    },
    getData(){
      getServiceMoney({btsId:0,
        b2cTaskTypeId:this.tabsActive,
        servicePrice:0,
        chargesPrice: 0}).then(res => {
        if (res.success){
          this.tableData = res.data;
        }
      });
    },
    handleCurrentChange(row, event, column) {
      console.log(row, event, column, event.currentTarget)
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}

span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}
</style>
